import inscripciones from '@/api/cifra/transporte/inscripciones';
import { dateToDatepicker, datepickerToDate, isValidDate } from '../../../libs/dates';
import ComponentesJQuery from '../../../mixins/cifra/ComponentesJQuery';
import SelectorTurno from './SelectorTurno.vue';
import SelectorDatosTurno from './SelectorDatosTurno.vue';
import Overlay from '../../../libs/cifra/overlay';

export default {
  template: '#inscripcion-form-template',
  mixins: [ComponentesJQuery],
  components: {
    SelectorTurno, SelectorDatosTurno,
  },
  props: ['id', 'redirectUrl', 'usuarioId', 'turno', 'fechaInicioInicial', 'fechaFinInicial', 'diasSemanaInicial'],
  data() {
    const turnos = [];
    if (this.turno) {
      turnos.push(this.turno);
    }

    return {
      fechaInicio: this.fechaInicioInicial,
      fechaFin: this.fechaFinInicial,
      turnos,
      diasSemana: [1, 2, 3, 4, 5],
      guardando: false,
    };
  },
  computed: {
    puedeGuardar() {
      if (!this.fechaInicio || !this.fechaFin || !this.turnos.length) {
        return false;
      }

      let todoOK = true;
      this.turnos.forEach((turno) => {
        if (!turno.parada_id || !turno.asiento) {
          todoOK = false;
        }
      });
      return todoOK;
    },
    paramsTurnos() {
      const params = {};
      if (this.fechaInicio) {
        params.fecha = this.fechaInicio;
      }
      return params;
    },
    numeroTurnos() {
      return this.turnos ? this.turnos.length : 0;
    },
    fechaInicioDatePicker: {
      get() {
        if (this.fechaInicio) {
          return dateToDatepicker(new Date(this.fechaInicio));
        }
        return null;
      },
      set(newValue) {
        const nueva = new Date(newValue);
        if (isValidDate(nueva)) {
          this.fechaInicio = datepickerToDate(nueva);
        } else {
          this.fechaInicio = null;
        }
      },
    },
    fechaFinDatePicker: {
      get() {
        if (this.fechaFin) {
          return dateToDatepicker(new Date(this.fechaFin));
        }
        return null;
      },
      set(newValue) {
        const nueva = new Date(newValue);
        if (isValidDate(nueva)) {
          this.fechaFin = datepickerToDate(nueva);
        } else {
          this.fechaFin = null;
        }
      },
    },
  },
  mounted() {
    if (this.fechaInicioInicial) {
      this.fechaInicio = this.fechaInicioInicial;
    }
    if (this.fechaFinInicial) {
      this.fechaFin = this.fechaFinInicial;
    }
    if (this.diasSemanaInicial) {
      this.diasSemana = this.diasSemanaInicial;
    }
  },
  watch: {
    numeroTurnos() {
      if (this.numeroTurnos !== 1) {
        return;
      }
      // La fecha de inicio es la que provoca la carga de los turnos, no hay que actualizarla
      this.fechaFin = this.turnos[0].fecha_fin;
    },
  },
  methods: {
    guardar() {
      this.guardando = true;
      const overlay = new Overlay(this.$el);
      overlay.show();
      inscripciones.guardar(this.dataToModel()).then(() => {
        this.guardando = false;
        overlay.hide();
      }).catch(() => {
        this.guardando = false;
        overlay.hide();
      });
    },
    dataToModel() {
      return {
        redirect_url: this.redirectUrl,
        transporte_inscripcion: {
          id: this.id,
          usuario_id: this.usuarioId,
          fecha_inicio: this.fechaInicio,
          fecha_fin: this.fechaFin,
          turnos: this.turnos,
          dias_semana: this.diasSemana,
        },
      };
    },
  },
};
